/* eslint-disable import/no-unresolved */
// import { Dispatch, SetStateAction } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { setStepDetails } from "src/redux/Actions/common";
import BankDetails from "./BankDetails";
import CustomButton from "../../../../shared/CustomButton";
import GeneralDetails from "./GeneralDetails";
import ReviewHeading from "../../../../shared/ReviewHeading";

// interface Props {
//   stepNo: number;
//   setStepNo: Dispatch<SetStateAction<number>>;
// }
function GeneralReview() {
  const dispatch = useDispatch();
  const reviewStepNumber = useAppSelector((state): any => state.stepDetails.reviewStepNo);
  const parentStepNumber = useAppSelector((state): any => state.stepDetails.parentStepNo);
  function onBack() {
    // setStepNo(stepNo);
    dispatch(setStepDetails({ parentStepNo: parentStepNumber - 1 }));
    window.scrollTo(0, 0);
  }
  function onNext() {
    // setStepNo(stepNo + 1);
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber + 1 }));
    window.scrollTo(0, 0);
  }
  return (
    <div className="lg:ml-24 lg:mr-24 pb-10 max-sm:ml-4 md:max-lg:px-10 max-sm:mr-4  font-montserrat">
      <ReviewHeading label="General Details" />
      <GeneralDetails />
      <BankDetails />
      {/* eslint-disable-next-line react/jsx-no-bind */}
      <CustomButton onBack={onBack} onNext={onNext} />
    </div>
  );
}
export default GeneralReview;
